import { autoinject, customElement, bindingMode, newInstance } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ValidationController } from 'aurelia-validation';
import { cloneDeep } from 'framework/script_utilities/object-equalizer';
import { ValidationHelper } from '../support/validation';

@autoinject
@customElement('as-widget-stack')
export class WidgetStack {
  @bindable items: unknown[];
  @bindable kind: string = null;
  @bindable disabled = false;
  @bindable emptyItemTemplate: unknown;
  newItem: unknown = null;
  @bindable({ defaultBindingMode: bindingMode.fromView }) newItemWidgetVisible = false;
  @bindable addNewItem: (args: ItemEventArgs) => Promise<void> = null;
  @bindable removeItem: (args: ItemEventArgs) => Promise<void> = null;
  @bindable widgetButtons: WidgetButton[] = null;


  constructor(private validationHelper: ValidationHelper, @newInstance() private validationController: ValidationController) {
  }

  emptyItemTemplateChanged() {
    this.newItem = cloneDeep(this.emptyItemTemplate);
    this.newItemWidgetVisible = false;
  }

  async removeItemInternal(item: unknown) {
    if (this.removeItem != null)
      await this.removeItem({ item: item });
    else
      this.items.splice(this.items.indexOf(item), 1);
  }

  showNewItemWidget() {
    this.newItemWidgetVisible = true;
  }

  async addNewItemInternal() {
    if (await this.validationHelper.validate(this.validationController)) {
      if (this.addNewItem != null)
        await this.addNewItem({ item: this.newItem });
      else
        this.items.unshift(this.newItem);
      this.newItem = cloneDeep(this.emptyItemTemplate);
      this.newItemWidgetVisible = false;
    }
  }

  cancelAddNewItem() {
    this.newItem = cloneDeep(this.emptyItemTemplate);
    this.newItemWidgetVisible = false;
  }
}

export interface ItemEventArgs { item: unknown };

export interface WidgetButton {
  title: string;
  icon: string;
  onClick: (item: unknown) => void;
}
